var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.9993 11.6667C54.716 11.6667 42.291 24.0917 42.291 39.375C42.291 54.3667 54.016 66.5 69.2994 67.025C69.766 66.9667 70.2327 66.9667 70.5827 67.025C70.6994 67.025 70.7577 67.025 70.8743 67.025C70.9327 67.025 70.9327 67.025 70.991 67.025C85.9244 66.5 97.6493 54.3667 97.7077 39.375C97.7077 24.0917 85.2827 11.6667 69.9993 11.6667Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6336 82.5417C83.3586 71.6917 56.8169 71.6917 40.4253 82.5417C33.0169 87.5 28.9336 94.2083 28.9336 101.383C28.9336 108.558 33.0169 115.208 40.3669 120.108C48.5336 125.592 59.2669 128.333 70.0003 128.333C80.7336 128.333 91.4669 125.592 99.6336 120.108C106.984 115.15 111.067 108.5 111.067 101.267C111.009 94.0917 106.984 87.4417 99.6336 82.5417Z",
    fill: "white",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.20cf8712401cd732b13279fc2629681f.svg";
export { ForwardRef as ReactComponent };